import React from 'react';
import {ArrowForwardRounded, LeaderboardRounded} from "@mui/icons-material";
import {Button, Divider, Table} from "antd";
import {useLocation, useSearchParams} from "wouter";
import TruncatedText from "../utils/TruncatedText";

const QuickReportSummaryCard = (props) => {
    const {
        className='7 Kangaroo',
        avgActivityCount = '8',
        avgSessionsCount = '6',
        leaderboard,
        classId
    } = props;

    const [location, navigate] = useLocation();

    const handleClick = () => {
        navigate(`/web/ui/view/reports/activityReport/${classId}`);
    };

    return (
        <div className={'ch-quick-report-card'}>
            <Button type={'link'} onClick={() => handleClick()} className={'ch-quick-report-card-button'}>
                <h3><TruncatedText text={className} /></h3>
                <ArrowForwardRounded />
            </Button>
            <Divider style={{margin: '6px 0'}} />
            <dl className={'ch-quick-report-quick-stats'}>
                <div className="ch-quick-report-card-detail">
                    <dt>Avg. logins<br/> past 7d</dt>
                    <dd className="ch-quick-report-card-number">{avgSessionsCount}</dd>
                </div>
                <div className="ch-quick-report-card-detail">
                    <dt>Avg. activities<br/> past 7d</dt>
                    <dd className="ch-quick-report-card-number">{avgActivityCount}</dd>
                </div>
            </dl>
            <Divider style={{margin: '6px 0'}} />
            <div className={'ch-quick-report-card-leaderboard'}>
                <div>
                    <h4>Leaderboard</h4>
                    <LeaderboardRounded aria-hidden={true} />
                </div>
                <table className="ch-quick-report-card-table">
                    <thead>
                    <tr>
                        <th>Student</th>
                        <th>Activities</th>
                    </tr>
                    </thead>
                    <tbody>
                    {leaderboard.map((student, index) => {
                        return(
                            <tr key={index}>
                                <td>{student.name}</td>
                                <td>{student.activities}</td>
                            </tr>
                            )
                    })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default QuickReportSummaryCard;